import { Link } from 'react-router-dom'
import netzence from '../../images/Frame 2147228713.png'
import image1 from '../../images/sus3.png'
import image2 from '../../images/TimiAndChuka.png'
import image3 from '../../images/image 139.png'
import Header from '../shared/Header'
import Footer from '../shared/Footer'
import sportlight from '../../images/sus1.png'
function BlogPost2() {

     const blogs = [
    {
      id: 1,
      badge: "Sustainable Farming",
      badgeColor: "#7BC216",
      title: "Netzence, Ministry of Livestock Development detect rapid seasonal Methane spikes in livestock systems",
      description: "Nigeria is finally beginning to see what has long remained hidden behind estimates and assumptions: how livestock methane emissions behave...",
      source: "05/02/2026",
      image: image1,
      readMoreLink: "#"
    },
    {
      id: 2,
      badge: "Carbon Credit",
      badgeColor: "#3B3B3B",
      title: "Turning Lagos forests into climate revenue asset  Netzence",
      description: "In a bid to increase revenue for the country, Netzence sustainability Limited has said that baseline studies and carbon credits ",
      source: "18/09/2026",
      image: image2,
      readMoreLink: "#"
    },
    {
      id: 3,
      badge: "Global Footprint Network",
      badgeColor: "#00AED9",
      title: "The United Nations welcomes Netzence Sustainability Limited into the United Nations Global Compact.",
      description: "Netzence Sustainability Limited is proud to announce its official acceptance as a participant in the United Nations Global Compact...",
      source: "18/07/2025",
      image: image3,
      readMoreLink: "#"
    }
  ];
  return (
<>

<Header/> 
<Link to="/blogs">
<div className='ml-72 text-[14px] flex pt-20'>
    Return to blog
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5 18L15.5 12L9.5 6" stroke="#898989" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


</div>
</Link>
<div className='ml-72 text-[24px] font-bold'>Netzence partners with Ministry of Livestock, Germany’s GIZ to conduct livestock monitoring capacity-building</div>
<div className='ml-72 flex gap-5 mt-10 '>
    <img loading='lazy' src={netzence} alt="netzence" className='w-[48px]'></img>


    <div>
        <div className='text-[16px] mb-3'>
            Netzence 
        </div>
        <div className='flex items-center gap-3 '>
            December 28, 2025 <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="3" cy="3" r="3" fill="#898989"/>
</svg>
7 mins read
        </div>
    </div>


</div>
<div className='ml-72 mr-72 mt-20'>
    <img loading='lazy' src={sportlight} alt="spotlight" className='object-cover w-[1200px]'></img>
</div>

 <div className="flex flex-col items-start gap-4 w-full max-w-[1152px] h-auto mt-20 ml-72" >
      {/* Paragraph 1 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Netzence Sustainability Limited (Netzence) has taken a significant step toward strengthening Nigeria’s climate accountability and agricultural sustainability framework by partnering with the Federal Ministry of Livestock Development (FMLD) and the German Corporation for International Cooperation (GIZ) to deliver comprehensive Livestock Methane Baseline Monitoring Capacity-Building programmes in Ibadan and Abuja, Nigeria.      </p>

      {/* Paragraph 2 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
The initiative brought together policymakers, technical experts, researchers, academics, ministry staff, and field practitioners with a shared goal: to build practical, hands-on capacity for measuring, monitoring, and validating methane emissions from Nigeria’s livestock sector, one of the country’s most important yet least quantified sources of greenhouse gas (GHG) emissions.      </p>

      {/* Paragraph 3 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Rather than focusing on theory alone, the capacity-building programmes were designed to equip participants with real tools, applied methodologies, and operational systems that will be deployed immediately across Nigeria’s livestock value chain. It represents the beginning of a longer national journey toward credible methane baselines, climate transparency, and investment-ready emissions data that can support policy, planning, and international engagement. According to Associate Professor Sadiq Sani, Founder and Chief Executive Officer of Netzence, the programmes are geared towards supporting President Bola Ahmed Tinubu’s livestock ambition on food security, farmer-herder conflict resolution, and economic development, as well as the 2030 emission reduction target, 2050/2060 emission net zero targets, and the United Nations Sustainable Development Goals (SDGs).      </p>

      {/* Paragraph 4 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Methane remains one of the most potent short-lived climate pollutants, and livestock systems account for a significant share of methane emissions globally. In Nigeria, however, the challenge has never been awareness of the issue, but rather the ability to measure it accurately and consistently. For years, livestock methane emissions have been estimated using broad assumptions rather than field-level data, limiting Nigeria’s ability to design targeted mitigation strategies, access climate finance, or participate fully in emerging carbon markets. These capacity-building programmes directly addressed that gap by focusing on measurement as the foundation for action. “We are equipping the value chain across the livestock development sector with the capabilities of enhancing sustainability practices and generating additional revenues, said Associate Professor Sadiq Sani.”      </p>

      {/* Paragraph 5 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Led by Netzence, the sessions were structured to strengthen participants’ understanding of methane baseline monitoring frameworks while providing hands-on exposure to Netzence’s proprietary technologies and tools required to generate credible data. The programmes were delivered as capacity-building, with integrated training modules, live demonstrations, and applied learning sessions tailored to Nigeria’s livestock realities, from pastoral systems to semi-intensive operations. Participants were guided through how methane emissions are measured, what data is required, why classification of confidential data is important, how monitoring tools function, and how the resulting information becomes useful for national reporting, policy development, Nigeria’s carbon market framework, and future market mechanisms. It was attended by officials and experts from the Federal Ministry of Livestock Development, National Bureau of Statistics (NBS), Academia, and other institutions. Some participants in attendance were Dr Alike Peters (Director, FMLD and Project Team Lead), Dr Chinwe Ezejiofor (Director, FMLD), Dr Adamu Y. Dakogi (Director, FMLD) and Mr Bello Liman (Principal Animal Husbandry Officer, FMLD) in Abuja; while in Ibadan it included: Dr Olasoju Taiwo (Deputy Director, FMLD); Mr Olukayode Akinboro (Assistant Director, FMLD); Prof. Nwakpu Petrus Emeka (Senior Lecturer, Ebonyi State University); Mr Lola Uthman (Statistician, NBS) and Mr JohnMark Oseghe (Chief Statistical Officer, NBS).       </p>

      {/* Paragraph 6 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“Practical knowledge exchange is a key mechanism to drive the growth of the sector and enhance the realisation of Nigeria’s new National Livestock Plan (N-LMP) that focuses on transforming the sector and boosting food security and economic growth, and attracting investments, said Associate Professor Sadiq Sani.”      </p>

      {/* Paragraph 7 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Early clean-mobility pilots in Nigeria already show measurable results. Where smart operational tools are deployed, transport costs have fallen by 30 to 60 per cent without sacrificing reliability. Ride-pooling alone can halve fares—from about ₦2,400 for solo trips to as low as ₦1,200—while reducing empty mileage that erodes operator pAt the centre of the training was Netzence’s methane monitoring approach, which monitors and captures real-time field-level data transmitted to its CloseCarbon technology platform, supported by blockchain and Artificial Intelligence (AI) technologies. Participants were introduced to standardised methane baseline methodologies aligned with international climate reporting frameworks, as well as verification-ready data systems designed to ensure traceability, credibility, and audit readiness. The programmes deliberately demystified methane monitoring, translating complex climate systems into practical, usable processes that institutions can adopt and scale. “Seamless value chain integration without single point of failure and conflicts are at the centre of our approach, said Associate Professor Sadiq Sani.”rofits. In several cities, on-demand shared rides have improved travel predictability and strengthened access to healthcare, education, and employment centres.      </p>

      {/* Paragraph 8 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
The capacity-building sessions were delivered in both Ibadan and Abuja to ensure technical depth and policy relevance. In Ibadan, researchers, academics, and field practitioners engaged in detailed technical discussions, methodological alignment, and research integration, creating space for knowledge exchange and technical refinement. In Abuja, the focus shifted toward policy actors and ministry staff, reinforcing national coordination and ensuring that methane monitoring capacity is embedded within government systems from the outset. Together, the two locations reinforced single objective: building national capability rather than isolated expertise.      </p>

      {/* Paragraph 9 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
These programmes were not designed as a one-off intervention but as the foundation of an ongoing national effort. Netzence, working alongside FMLD and GIZ, is positioning this work as the first phase of a broader roadmap that includes expanded training across additional states and livestock corridors, deeper integration of monitoring systems into national data platforms, continued technical support for ministries, researchers, and field teams, and open opportunities for other organisations, universities, development partners, and private-sector actors to join and contribute. The approach intentionally creates room for collaboration, scale, and shared ownership, recognising that credible methane monitoring requires a multi-stakeholder ecosystem.      </p>

      {/* Paragraph 10 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Critical support for the programmes was provided by GIZ, an international enterprise owned by the German Federal Government and operating across more than 130 countries. Their involvement underscores Germany’s continued commitment to climate action, capacity-building, and sustainable development partnerships in Nigeria.      </p>

      {/* Paragraph 11 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
By focusing on livestock methane baselines, the programmes align with Nigeria’s broader climate objectives, including improved GHG reporting, targeted mitigation planning, and readiness for future climate finance mechanisms. More importantly, it strengthens Nigeria’s ability to generate, own, and defend its own emissions data, reducing reliance on estimates and reinforcing national climate sovereignty. This shift from estimation to measurement is essential for translating climate ambition into operational outcomes.      </p>

      {/* Paragraph 12 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Netzence extends special appreciation and gratitude to the President of the Federal Republic of Nigeria, President Bola Ahmed Tinubu, the Secretary to the Government of the Federation, Senator Dr George Akume, the Honourable Minister of Livestock Development, Idi Mukhtar Maiha, the Permanent Secretary of the Federal Ministry of Livestock Development, Dr Chinyere Ijeoma Akujobi, the Permanent Secretary of the Service Policies and Strategies Office at the Office of the Head of Civil Service of the Federation, Dr Ishiyaku Musa Mohammed, Dr Alike Peters, Dr Dakogi, Members of the Technical Working Group at FMLD, dedicated ministry staff, other government’s ministries and agencies, participating professors, doctors, universities, researchers, technical institutions, and all programme participants whose engagement and contributions made the sessions impactful. Their leadership and commitment continue to drive Nigeria’s climate capacity forward.      </p>
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
The Livestock Methane Baseline Monitoring Capacity-Building programmes signal the beginning of a new phase in Nigeria’s climate journey, one built on real-time data, extended collaboration, and practical systems. More results are expected, more partnerships are welcome, and more capacity-building sessions are planned. As Nigeria strengthens its ability to measure what matters, Netzence remains committed to supporting policymakers, institutions, researchers, and industry experts with the technologies and tools needed to turn climate ambition into measurable, credible action.</p>    </div>

   <div className="items-start gap-10 w-full max-w-[1200px] h-[43px] ml-72">
        <h2 
          className="text-[#0D924F] font-bold text-4xl leading-[43px] w-[225px] h-[43px] mt-10"
          style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
        >
          Related Blogs
        </h2>
      </div>

     <div className=" items-start gap-10 w-full max-w-[1201px] h-auto mt-20 ">
      {/* Header */}
   
      {/* Cards Container */}
      <div className="flex flex-row items-stretch gap-8 w-full flex-wrap ml-72 lg:flex-nowrap mb-20">
        {blogs.map((blog) => (
          <div 
            key={blog.id}
            className="flex flex-col items-center pb-6 gap-4 w-[379px] h-[544px] bg-white shadow-[0px_8px_24px_rgba(149,157,165,0.2)] rounded-2xl shrink-0"
          >
            {/* Image */}
            <div className="w-[378px] h-[282px] rounded-t-2xl overflow-hidden">
              <img 
                src={blog.image} 
                alt={blog.title}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Article Content */}
            <div className="flex flex-col items-start gap-4 w-[352px] h-[222px]">
              {/* Badge */}
              <div 
                className="flex flex-row justify-center items-center px-1.5 py-0.5 gap-2 h-[25px] rounded"
                style={{ backgroundColor: blog.badgeColor }}
              >
                <span 
                  className="text-white font-medium text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.badge}
                </span>
              </div>

              {/* Text Container */}
              <div className="flex flex-col items-start gap-3 w-full">
                {/* Title */}
                <h3 
                  className="text-[#3B3B3B] font-semibold text-[20px] leading-[24px] tracking-[-0.02em] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv01' on, 'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.title}
                </h3>
                
                {/* Description */}
                <p 
                  className="text-[#898989] font-normal text-[14px] leading-[20px] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.description}
                </p>
              </div>

              {/* Footer */}
              <div className="flex flex-row justify-between items-center w-full">
                <span 
                  className="text-[#3B3B3B] font-normal text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.source}
                </span>
                
                <a 
                  href={blog.readMoreLink}
                  className="flex flex-row justify-center items-center gap-2 transition-all duration-150 hover:opacity-80 group"
                >
                  <span 
                    className="text-[#006633] font-medium text-[14px] leading-[20px]"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Read More
                  </span>
                  <div className="relative w-2.5 h-4 flex items-center justify-center">
                    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 1L6.5 6L1.5 11" stroke="#006633" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
<Footer/>
</>
  )
}

export default BlogPost2